// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function ResellerBenAdminPEPMRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (state.resellerCustomerQuoteValues.benAdminPEPM > 0)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {getString('product.ResellerBenAdminPEPMRow.Title')}
            </div>
            <div className='col'>
               {state.productBenefitsAdministrationEECount >
               state.product_list['benAdmin']['MinimumEmployees']
                  ? formatFloatAsCurrencySymbol(
                       state.resellerCustomerQuoteValues.benAdminPEPM,
                       state.currencyObject,
                    )
                  : 'Flat Rate'}
            </div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.resellerCustomerQuoteValues.benAdminTotalPrice,
                  state.currencyObject,
               )}
            </div>
         </div>
      )
}
